import { useState, useEffect } from "react";

import { useAppDispatch, useAppSelector } from "@app/store";
import { setRecipes, useDeleteRecipeMutation, useLazyGetRecipesQuery } from "@modules/recipe";
import { FilterParams } from "types";
import { PARAMS } from "@constants/index";
import { useUpdateVisibalityInHomeMutation } from "@modules/recipe/api/recipe.api";
import { IRecipe } from "@modules/recipe/types";
import { toast } from 'react-toastify';

export const useRecipesLogic = () => {
  const dispatch = useAppDispatch();
  const recipesList = useAppSelector((state) => state.recipe.recipes)
  const [updateVisibalityInHome] = useUpdateVisibalityInHomeMutation()

  const [getRecipes] = useLazyGetRecipesQuery()
  const [deleteRecipe] = useDeleteRecipeMutation()
  const [pagesCount, setPagesCount] = useState<number>(1);
  const [filters, setFilters] = useState<FilterParams>({
    limit: PARAMS.LIMIT,
    offset: PARAMS.OFFSET,
  })

  const handleGetRequest = async () => {
    try {
      const responseRecipes = await getRecipes(filters).unwrap();

      dispatch(setRecipes(responseRecipes.recipes));
      setPagesCount(responseRecipes.count || 1)
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteRecipe = async (id?: string) => {
    if (!id) {
      return null
    }

    try {
      await deleteRecipe({ id })
      handleGetRequest()
    } catch (error) {
      console.log(error);
    }
  }

  const handlePagination = (page: number, limit: number) => {
    const offset = page === 1 ? PARAMS.OFFSET : limit * (page - 1)

    setFilters({ limit, offset })
  }

  const handleChange = (recipe: IRecipe) => {
    if (!recipe?.id) {
      return
    }

    const alternativeValue = !recipe.activeInHome;

    updateVisibalityInHome({
      id: recipe.id,
      activeInHome: alternativeValue
    })
      .unwrap()
      .then(() => {
        const updated = recipesList?.map((item) => {
          if (item.id === recipe?.id) {
            return { ...item, activeInHome: alternativeValue }
          }

          return item
        })

        dispatch(setRecipes(updated));
      })
      .catch((error) => {
        if (error?.data?.message) {
          toast(error?.data?.message, { type: 'warning' })

          return
        }

        console.log(error);
      })
  }

  useEffect(() => {
    handleGetRequest()
  }, [filters])

  return {
    recipesList,
    handleChange,
    handleDeleteRecipe,
    pagesCount,
    handlePagination
  };
}
